import script from "./marketPrices.vue?vue&type=script&setup=true&lang=js"
export * from "./marketPrices.vue?vue&type=script&setup=true&lang=js"

import "./marketPrices.vue?vue&type=style&index=0&id=c4641104&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4641104"]])

export default __exports__